export default __webpack_public_path__ + "static/media/transparent_newspapers_main_header.288a8590.png";